// ============================================================================
//  CONFIG ÚNICA DO ESTUDANTIL
//  Troque AQUI (um só lugar) a URL do backend e a base dos QR codes.
//  Sem variáveis de ambiente — valores fixos.
// ============================================================================

// URL do backend (server). Fonte única — o currentServer da API herda daqui.
export const API_URL = 'https://api.unaeestudantil.com.br' //'http://localhost:3002';

// Base usada em TODOS os QR codes / links de validação do projeto.
export const QR_BASE_URL = 'https://www.unaecarteirinha.com.br';

// Monta a URL de validação pública de uma carteirinha (conteúdo do QR).
export const validadorUrl = (cpf, codigoUso) =>
    `${QR_BASE_URL}/validar/${String(cpf || '').replace(/\D/g, '')}/${codigoUso}`;

// Contato de atendimento (WhatsApp) — DDI+DDD+número, só dígitos. Fonte única.
export const ATENDENTE_WHATSAPP = '5511958859344';

// Mensagem padrão ao abrir a conversa pelo botão flutuante / "falar com atendente".
export const ATENDENTE_MSG = 'Olá! Quero saber como ter minha carteirinha estudantil UNAE.';

// Monta o link wa.me já com a mensagem (usa a padrão se nenhuma for passada).
export const whatsappUrl = (mensagem = ATENDENTE_MSG) =>
    `https://wa.me/${ATENDENTE_WHATSAPP}?text=${encodeURIComponent(mensagem)}`;
